import "core-js";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { LoginAvatar } from "@invosys/invosys-ui";
import {
  StylesProvider,
  createGenerateClassName,
} from "@material-ui/core/styles";
import ResetPassword from "./ResetPassword/ResetPassword";
import Branding from "./Branding/Branding";
import Login from "./Login/Login";
import Navigation from "./Navigation/Navigation";
import Service from "./services/Service.jsx";
import ServiceDialog from "./services/ServiceDialog.jsx";
import ServiceHistory from "./enterprise-service/ServiceHistory.jsx";
import Summary from "./enterprise-service/Summary.jsx";
import MFA from "./Login/MFA";
import DestinationSearch from "./DestinationSearch/DestinationSearch";

const generateClassName = createGenerateClassName({
  productionPrefix: "falcon",
  disableGlobal: true,
});

const generateBrandingClassName = createGenerateClassName({
  productionPrefix: "branding",
  disableGlobal: true,
});

window.renderLoginAvatar = (
  mountPoint,
  displayName,
  isAdministrator,
  isSysAdmin,
  clientId,
  clientName,
  currentClientId,
  hasChildren,
  auditUserId,
  auditUserEmail,
  passwordAge,
) => {
  ReactDOM.render(
    <StylesProvider generateClassName={generateClassName}>
      <LoginAvatar
        displayName={displayName}
        isAdministrator={isAdministrator}
        isSysAdmin={isSysAdmin}
        clientId={clientId}
        clientName={clientName}
        currentClientId={currentClientId}
        hasChildren={hasChildren}
        auditUserId={auditUserId}
        auditUserEmail={auditUserEmail}
        passwordAge={passwordAge}
      />
    </StylesProvider>,
    document.querySelector(mountPoint),
  );
};

window.renderBranding = () => {
  if (document.getElementById("advanced-branding-root")) {
    ReactDOM.render(
      <StylesProvider generateClassName={generateBrandingClassName}>
        <Branding />
      </StylesProvider>,
      document.getElementById("advanced-branding-root"),
    );
  }
};

window.renderNavigation = () => {
  if (document.getElementById("falcon-main-navigation")) {
    ReactDOM.render(
      <StylesProvider generateClassName={generateBrandingClassName}>
        <Navigation />
      </StylesProvider>,
      document.getElementById("falcon-main-navigation"),
    );
  }
};

window.reloadNavigation = () => {
  if (document.getElementById("navigationRoot")) {
    ReactDOM.unmountComponentAtNode(document.getElementById("navigationRoot"));
    ReactDOM.render(<Navigation />, document.getElementById("navigationRoot"));
  }
  if (document.getElementById("falcon-main-navigation")) {
    ReactDOM.unmountComponentAtNode(
      document.getElementById("falcon-main-navigation"),
    );
    ReactDOM.render(
      <StylesProvider generateClassName={generateBrandingClassName}>
        <Navigation />
      </StylesProvider>,
      document.getElementById("falcon-main-navigation"),
    );
  }
};

window.renderService = (mountPoint, id, clientId) => {
  ReactDOM.render(
    <Service readonly="true" serviceId={id} clientId={clientId} />,
    document.getElementById(mountPoint),
  );
};

window.renderServiceDialog = (
  mountPoint,
  id,
  clientId,
  serviceJson,
  serviceVersion,
  serviceDateString,
  isLiveVersion,
) => {
  ReactDOM.render(
    <ServiceDialog
      serviceJson={serviceJson}
      serviceId={id}
      clientId={clientId}
      serviceVersion={serviceVersion}
      serviceDate={serviceDateString}
      isLiveVersion={isLiveVersion}
    />,
    mountPoint,
  );
};

window.renderReactSummary = (mountPoint, moduleGroupId) => {
  ReactDOM.render(
    <Summary moduleGroupId={moduleGroupId} />,
    document.getElementById(mountPoint),
  );
};

window.clearReactSummary = (mountedList) => {
  console.debug("Clearing", mountedList.selector);
  if (mountedList.selector) {
    ReactDOM.unmountComponentAtNode(
      document.querySelector(mountedList.selector),
    );
  }
};

window.renderReactHistory = (
  mountPoint,
  moduleGroupId,
  created,
  createdBy,
  modified,
  modifiedBy,
  selectedValue,
) => {
  ReactDOM.render(
    <ServiceHistory
      moduleGroupId={moduleGroupId}
      created={created}
      createdBy={createdBy}
      modified={modified}
      modifiedBy={modifiedBy}
      selectedFileDate={selectedValue}
    />,
    document.getElementById(mountPoint),
  );
};
window.renderDestinationSearch = () => {
  if (document.getElementById("destinationSearchContainer")) {
    ReactDOM.render(
      <DestinationSearch />,
      document.getElementById("destinationSearchContainer"),
    );
  }
};

if (document.getElementById("root")) {
  ReactDOM.render(
    <BrowserRouter>
      <LoginAvatar
        displayName="Test React"
        isAdministrator={true}
        isSysAdmin={true}
        clientId="1005"
        clientName="5th Comm test"
        currentClientId="204108"
        hasChildren={true}
      />
    </BrowserRouter>,
    document.getElementById("root"),
  );
}

if (document.getElementById("forgottenPassword")) {
  ReactDOM.render(
    <ResetPassword />,
    document.getElementById("forgottenPassword"),
  );
}

if (document.getElementById("advanced-branding-root-int")) {
  ReactDOM.render(
    <StylesProvider generateClassName={generateBrandingClassName}>
      <Branding />
    </StylesProvider>,
    document.getElementById("advanced-branding-root-int"),
  );
}

if (document.getElementById("loginContainer")) {
  ReactDOM.render(<Login />, document.getElementById("loginContainer"));
}
if (document.getElementById("navigationRoot")) {
  ReactDOM.render(<Navigation />, document.getElementById("navigationRoot"));
}
if (document.getElementById("mfaContainer")) {
  ReactDOM.render(<MFA />, document.getElementById("mfaContainer"));
}
